import { render, staticRenderFns } from "./HelpManageOrders.vue?vue&type=template&id=17fb269c&"
import script from "./HelpManageOrders.vue?vue&type=script&lang=js&"
export * from "./HelpManageOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports